<template>
  <section class="page-container analytics-page">
    <div class="toolbar">
      <el-form :inline="true">
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="startDate"
            type="date"
            placeholder="选择开始日期"
            value-format="yyyy-MM-dd"
            :picker-options="startPickerOptions"
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="endDate"
            type="date"
            placeholder="选择结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="endPickerOptions"
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchData">查询</el-button>
          <el-button @click="resetFilters">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button size="small" @click="setTimeRange(7)">最近7天</el-button>
            <el-button size="small" @click="setTimeRange(30)">最近30天</el-button>
            <el-button size="small" @click="setTimeRange(90)">最近90天</el-button>
            <el-button size="small" @click="setTimeRange(0)">全部</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </div>

    <div v-loading="loading" class="charts-container">
      <el-row :gutter="20">
        <!-- 职位类型统计 - 饼图 -->
        <el-col :span="12">
          <el-card class="chart-card">
            <div slot="header" class="card-header">
              <span>职位类型分布</span>
              <span class="subtitle">统计时间段内各职位类型的发布数量</span>
            </div>
            <div ref="positionPieChart" class="chart" style="height: 400px"></div>
          </el-card>
        </el-col>

        <!-- 公司类型统计 - 饼图 -->
        <el-col :span="12">
          <el-card class="chart-card">
            <div slot="header" class="card-header">
              <span>公司类型分布</span>
              <span class="subtitle">统计时间段内各公司类型的发布数量</span>
            </div>
            <div ref="companyPieChart" class="chart" style="height: 400px"></div>
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top: 20px">
        <!-- 职位类型统计 - 柱状图 -->
        <el-col :span="12">
          <el-card class="chart-card">
            <div slot="header" class="card-header">
              <span>职位类型数量统计</span>
              <span class="subtitle">横向对比各职位类型的发布数量</span>
            </div>
            <div ref="positionBarChart" class="chart" style="height: 400px"></div>
          </el-card>
        </el-col>

        <!-- 公司类型统计 - 柱状图 -->
        <el-col :span="12">
          <el-card class="chart-card">
            <div slot="header" class="card-header">
              <span>公司类型数量统计</span>
              <span class="subtitle">横向对比各公司类型的发布数量</span>
            </div>
            <div ref="companyBarChart" class="chart" style="height: 400px"></div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 薪资分布统计 -->
      <el-row :gutter="20" style="margin-top: 20px">
        <el-col :span="24">
          <el-card class="chart-card">
            <div slot="header" class="card-header">
              <div style="display: flex; justify-content: space-between; align-items: center">
                <div>
                  <span>薪资分布统计</span>
                  <span class="subtitle">按最低薪资统计各区间的职位数量</span>
                </div>
                <div>
                  <el-button size="small" @click="showSalaryRangeDialog">自定义区间</el-button>
                  <el-select v-model="salaryRangePreset" size="small" @change="applySalaryPreset" style="width: 150px; margin-left: 10px">
                    <el-option label="默认区间" value="default" />
                    <el-option label="粗粒度" value="coarse" />
                    <el-option label="细粒度" value="fine" />
                  </el-select>
                </div>
              </div>
            </div>
            <div ref="salaryRangeChart" class="chart" style="height: 400px"></div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 自定义薪资区间对话框 -->
      <el-dialog title="自定义薪资区间" :visible.sync="salaryRangeDialogVisible" width="600px">
        <div style="margin-bottom: 15px">
          <el-button type="primary" size="small" @click="addSalaryRange">添加区间</el-button>
          <el-button size="small" @click="resetToDefaultRanges">恢复默认</el-button>
        </div>
        <el-table :data="customSalaryRanges" border>
          <el-table-column label="最小值 (K)" width="150">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.min"
                :min="0"
                :max="scope.row.max - 1"
                size="small"
                style="width: 100%"
              />
            </template>
          </el-table-column>
          <el-table-column label="最大值 (K)" width="150">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.max"
                :min="scope.row.min + 1"
                :max="999"
                size="small"
                style="width: 100%"
              />
            </template>
          </el-table-column>
          <el-table-column label="区间名称" width="150">
            <template slot-scope="scope">
              {{ scope.row.min }}K-{{ scope.row.max >= 999 ? scope.row.max + 'K+' : scope.row.max + 'K' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="removeSalaryRange(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer">
          <el-button @click="salaryRangeDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="applyCustomRanges">应用</el-button>
        </div>
      </el-dialog>

      <!-- 公司排行榜 -->
      <el-row :gutter="20" style="margin-top: 20px">
        <el-col :span="24">
          <el-card class="chart-card">
            <div slot="header" class="card-header">
              <span>公司发布职位数量排行榜</span>
              <span class="subtitle">统计时间段内各公司的职位发布数量（前100名）</span>
            </div>
            <el-table :data="companyRankData" border stripe max-height="500">
              <el-table-column type="index" label="排名" width="80" />
              <el-table-column prop="companyName" label="公司名称" min-width="200" />
              <el-table-column prop="count" label="发布数量" width="120" sortable />
              <el-table-column label="平均最低薪资" width="150" sortable :sort-method="(a, b) => (a.avgMinSalary || 0) - (b.avgMinSalary || 0)">
                <template slot-scope="scope">
                  {{ scope.row.avgMinSalary ? Math.round(scope.row.avgMinSalary) : 'N/A' }}
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>

      <!-- 数据表格 -->
      <el-row :gutter="20" style="margin-top: 20px">
        <el-col :span="12">
          <el-card class="chart-card">
            <div slot="header" class="card-header">
              <span>职位类型详细数据</span>
            </div>
            <el-table :data="positionTableData" border stripe max-height="400">
              <el-table-column prop="positionName" label="职位类型" />
              <el-table-column prop="count" label="发布数量" sortable />
              <el-table-column label="平均最低薪资" sortable :sort-method="(a, b) => (a.avgMinSalary || 0) - (b.avgMinSalary || 0)">
                <template slot-scope="scope">
                  {{ scope.row.avgMinSalary ? Math.round(scope.row.avgMinSalary) : 'N/A' }}
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>

        <el-col :span="12">
          <el-card class="chart-card">
            <div slot="header" class="card-header">
              <span>公司类型详细数据</span>
            </div>
            <el-table :data="companyTableData" border stripe max-height="400">
              <el-table-column prop="projectCategory" label="公司类型" />
              <el-table-column prop="count" label="发布数量" sortable />
              <el-table-column label="平均最低薪资" sortable :sort-method="(a, b) => (a.avgMinSalary || 0) - (b.avgMinSalary || 0)">
                <template slot-scope="scope">
                  {{ scope.row.avgMinSalary ? Math.round(scope.row.avgMinSalary) : 'N/A' }}
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </section>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'AnalyticsPage',
  data() {
    return {
      loading: false,
      startDate: null,
      endDate: null,
      startPickerOptions: {
        disabledDate: (time) => {
          // 开始时间不能晚于结束时间
          if (this.endDate) {
            return time.getTime() > new Date(this.endDate).getTime();
          }
          return false;
        },
      },
      endPickerOptions: {
        disabledDate: (time) => {
          // 结束时间不能早于开始时间
          if (this.startDate) {
            return time.getTime() < new Date(this.startDate).getTime();
          }
          return false;
        },
      },
      positionTableData: [],
      companyTableData: [],
      companyRankData: [],
      salaryRangeData: [],
      salaryRangePreset: 'default',
      salaryRangeDialogVisible: false,
      customSalaryRanges: [],
      chartInstances: {
        positionPie: null,
        companyPie: null,
        positionBar: null,
        companyBar: null,
        salaryRange: null,
      },
    };
  },
  mounted() {
    // 初始化自定义薪资区间为默认值
    this.resetToDefaultRanges();
    // 初始化为最近一个月
    this.resetFilters();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.destroyCharts();
  },
  methods: {
    setTimeRange(days) {
      if (days === 0) {
        // 全部数据
        this.startDate = null;
        this.endDate = null;
      } else {
        // 最近N天
        const end = new Date();
        const start = new Date();
        start.setDate(start.getDate() - days);
        this.startDate = this.formatDate(start);
        this.endDate = this.formatDate(end);
      }
      this.fetchData();
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    resetFilters() {
      // 重置为最近一个月
      const end = new Date();
      const start = new Date();
      start.setDate(start.getDate() - 30);
      this.startDate = this.formatDate(start);
      this.endDate = this.formatDate(end);
      this.fetchData();
    },
    async fetchData() {
      this.loading = true;
      try {
        const params = {};

        // 如果用户选择了时间范围，则使用用户选择的时间
        if (this.startDate && this.endDate) {
          // 将日期字符串转换为时间戳（毫秒）
          params.startTime = new Date(this.startDate + ' 00:00:00').getTime();
          params.endTime = new Date(this.endDate + ' 23:59:59').getTime();
        } else if (this.startDate) {
          params.startTime = new Date(this.startDate + ' 00:00:00').getTime();
        } else if (this.endDate) {
          params.endTime = new Date(this.endDate + ' 23:59:59').getTime();
        }

        // 如果使用了自定义薪资区间，传递给后端
        if (this.customSalaryRanges && this.customSalaryRanges.length > 0) {
          params.salaryRanges = JSON.stringify(this.customSalaryRanges.map(r => ({
            min: r.min * 1000,
            max: r.max * 1000,
          })));
        }

        const data = await this.axios.get('/api/admin/analysics/stats', {
          params,
        });

        // 如果后端返回了实际使用的时间范围，更新日期选择器
        if (data.startTime && data.endTime && !this.startDate && !this.endDate) {
          const startDate = new Date(data.startTime);
          const endDate = new Date(data.endTime);
          this.startDate = this.formatDate(startDate);
          this.endDate = this.formatDate(endDate);
        }

        this.positionTableData = data.positionStats || [];
        this.companyTableData = data.companyStats || [];
        this.companyRankData = data.companyRank || [];
        this.salaryRangeData = data.salaryRanges || [];

        this.$nextTick(() => {
          this.renderCharts();
        });
      } catch (error) {
        this.$message.error('获取数据失败: ' + (error.message || '未知错误'));
      } finally {
        this.loading = false;
      }
    },
    renderCharts() {
      this.renderPositionPieChart();
      this.renderCompanyPieChart();
      this.renderPositionBarChart();
      this.renderCompanyBarChart();
      this.renderSalaryRangeChart();
    },
    renderPositionPieChart() {
      if (this.chartInstances.positionPie) {
        this.chartInstances.positionPie.dispose();
      }

      const chartDom = this.$refs.positionPieChart;
      if (!chartDom) return;

      this.chartInstances.positionPie = echarts.init(chartDom);

      // 准备数据，前20个显示label，其他隐藏
      const chartData = this.positionTableData.map((item, index) => ({
        value: item.count,
        name: item.positionName || '未知',
        label: {
          show: index < 20, // 只显示前20个的label
          formatter: '{b}: {c}',
        },
      }));

      const option = {
        title: {
          text: '职位类型分布',
          left: 'center',
          top: 10,
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
        },
        legend: {
          type: 'scroll', // 使用可滚动的图例
          orient: 'vertical',
          left: 'left',
          top: 50,
          height: 300, // 限制图例高度
        },
        series: [
          {
            name: '职位类型',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['60%', '50%'], // 向右移动，为图例留出空间
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: 'bold',
              },
            },
            data: chartData,
          },
        ],
      };
      this.chartInstances.positionPie.setOption(option);
    },
    renderCompanyPieChart() {
      if (this.chartInstances.companyPie) {
        this.chartInstances.companyPie.dispose();
      }

      const chartDom = this.$refs.companyPieChart;
      if (!chartDom) return;

      this.chartInstances.companyPie = echarts.init(chartDom);

      // 准备数据，前20个显示label，其他隐藏
      const chartData = this.companyTableData.map((item, index) => ({
        value: item.count,
        name: item.projectCategory || '未知',
        label: {
          show: index < 20, // 只显示前20个的label
          formatter: '{b}: {c}',
        },
      }));

      const option = {
        title: {
          text: '公司类型分布',
          left: 'center',
          top: 10,
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            const item = this.companyTableData[params.dataIndex];
            const avgSalary = item.avgMinSalary ? `${Math.round(item.avgMinSalary)}` : 'N/A';
            return `${params.seriesName}<br/>${params.name}: ${params.value} (${params.percent}%)<br/>平均最低薪资: ${avgSalary}`;
          },
        },
        legend: {
          type: 'scroll', // 使用可滚动的图例
          orient: 'vertical',
          left: 'left',
          top: 50,
          height: 300, // 限制图例高度
        },
        series: [
          {
            name: '公司类型',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['60%', '50%'], // 向右移动，为图例留出空间
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: 'bold',
              },
            },
            data: chartData,
          },
        ],
      };
      this.chartInstances.companyPie.setOption(option);
    },
    renderPositionBarChart() {
      if (this.chartInstances.positionBar) {
        this.chartInstances.positionBar.dispose();
      }

      const chartDom = this.$refs.positionBarChart;
      if (!chartDom) return;

      this.chartInstances.positionBar = echarts.init(chartDom);
      const option = {
        title: {
          text: '职位类型数量统计',
          left: 'center',
          top: 10,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
        },
        yAxis: {
          type: 'category',
          data: this.positionTableData.map((item) => item.positionName || '未知'),
        },
        series: [
          {
            name: '发布数量',
            type: 'bar',
            data: this.positionTableData.map((item) => item.count),
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#83bff6' },
                { offset: 0.5, color: '#188df0' },
                { offset: 1, color: '#188df0' },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: '#2378f7' },
                  { offset: 0.7, color: '#2378f7' },
                  { offset: 1, color: '#83bff6' },
                ]),
              },
            },
          },
        ],
      };
      this.chartInstances.positionBar.setOption(option);
    },
    renderCompanyBarChart() {
      if (this.chartInstances.companyBar) {
        this.chartInstances.companyBar.dispose();
      }

      const chartDom = this.$refs.companyBarChart;
      if (!chartDom) return;

      this.chartInstances.companyBar = echarts.init(chartDom);
      const option = {
        title: {
          text: '公司类型数量统计',
          left: 'center',
          top: 10,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
        },
        yAxis: {
          type: 'category',
          data: this.companyTableData.map((item) => item.projectCategory || '未知'),
        },
        series: [
          {
            name: '发布数量',
            type: 'bar',
            data: this.companyTableData.map((item) => item.count),
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#fbc2eb' },
                { offset: 0.5, color: '#a6c1ee' },
                { offset: 1, color: '#a6c1ee' },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: '#fa709a' },
                  { offset: 0.7, color: '#fa709a' },
                  { offset: 1, color: '#fee140' },
                ]),
              },
            },
          },
        ],
      };
      this.chartInstances.companyBar.setOption(option);
    },
    renderSalaryRangeChart() {
      if (this.chartInstances.salaryRange) {
        this.chartInstances.salaryRange.dispose();
      }

      const chartDom = this.$refs.salaryRangeChart;
      if (!chartDom) return;

      this.chartInstances.salaryRange = echarts.init(chartDom);
      const option = {
        title: {
          text: '薪资分布统计',
          left: 'center',
          top: 10,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: (params) => {
            const item = params[0];
            return `${item.name}<br/>职位数量: ${item.value}`;
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: this.salaryRangeData.map((item) => item.rangeName),
          axisLabel: {
            interval: 0,
            rotate: 0,
          },
        },
        yAxis: {
          type: 'value',
          name: '职位数量',
        },
        series: [
          {
            name: '职位数量',
            type: 'bar',
            data: this.salaryRangeData.map((item) => item.count),
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#83bff6' },
                { offset: 0.5, color: '#188df0' },
                { offset: 1, color: '#188df0' },
              ]),
              borderRadius: [5, 5, 0, 0],
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#2378f7' },
                  { offset: 0.7, color: '#2378f7' },
                  { offset: 1, color: '#83bff6' },
                ]),
              },
            },
            label: {
              show: true,
              position: 'top',
              formatter: '{c}',
            },
          },
        ],
      };
      this.chartInstances.salaryRange.setOption(option);
    },
    showSalaryRangeDialog() {
      this.salaryRangeDialogVisible = true;
    },
    addSalaryRange() {
      const lastRange = this.customSalaryRanges[this.customSalaryRanges.length - 1];
      const newMin = lastRange ? lastRange.max : 0;
      this.customSalaryRanges.push({
        min: newMin,
        max: newMin + 5,
      });
    },
    removeSalaryRange(index) {
      if (this.customSalaryRanges.length <= 1) {
        this.$message.warning('至少保留一个区间');
        return;
      }
      this.customSalaryRanges.splice(index, 1);
    },
    resetToDefaultRanges() {
      this.customSalaryRanges = [
        { min: 0, max: 5 },
        { min: 5, max: 10 },
        { min: 10, max: 15 },
        { min: 15, max: 20 },
        { min: 20, max: 30 },
        { min: 30, max: 50 },
        { min: 50, max: 999 },
      ];
    },
    applySalaryPreset() {
      if (this.salaryRangePreset === 'default') {
        this.resetToDefaultRanges();
      } else if (this.salaryRangePreset === 'coarse') {
        // 粗粒度：更大的区间
        this.customSalaryRanges = [
          { min: 0, max: 10 },
          { min: 10, max: 20 },
          { min: 20, max: 40 },
          { min: 40, max: 999 },
        ];
      } else if (this.salaryRangePreset === 'fine') {
        // 细粒度：更小的区间
        this.customSalaryRanges = [
          { min: 0, max: 3 },
          { min: 3, max: 5 },
          { min: 5, max: 8 },
          { min: 8, max: 10 },
          { min: 10, max: 15 },
          { min: 15, max: 20 },
          { min: 20, max: 25 },
          { min: 25, max: 30 },
          { min: 30, max: 40 },
          { min: 40, max: 50 },
          { min: 50, max: 999 },
        ];
      }
      this.applyCustomRanges();
    },
    applyCustomRanges() {
      // 排序区间
      this.customSalaryRanges.sort((a, b) => a.min - b.min);

      // 重新计算薪资分布
      this.calculateCustomSalaryDistribution();

      this.salaryRangeDialogVisible = false;
      this.$message.success('已应用自定义区间');
    },
    calculateCustomSalaryDistribution() {
      // 重新查询数据，使用自定义区间
      this.fetchData();
    },
    handleResize() {
      Object.values(this.chartInstances).forEach((chart) => {
        if (chart) {
          chart.resize();
        }
      });
    },
    destroyCharts() {
      Object.values(this.chartInstances).forEach((chart) => {
        if (chart) {
          chart.dispose();
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.analytics-page {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: 100vh;

  .toolbar {
    background: #fff;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .charts-container {
    .chart-card {
      margin-bottom: 20px;

      .card-header {
        display: flex;
        flex-direction: column;

        span:first-child {
          font-size: 16px;
          font-weight: bold;
          color: #303133;
        }

        .subtitle {
          font-size: 12px;
          color: #909399;
          margin-top: 4px;
        }
      }

      .chart {
        width: 100%;
      }
    }
  }
}
</style>
